import { CommonModule } from '@angular/common';
import { Component, output, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  Checkbox,
  createPaymentAccountSignal,
  Icon,
} from '@millionshow/client-libs';

@Component({
  selector: 'app-terms-agreement',
  standalone: true,
  imports: [CommonModule, FormsModule, Checkbox, Icon],
  template: `
    <div class="w-full flex flex-col gap-6">
      <div class="w-full flex flex-col gap-6">
        <div
          class="border border-zinc-200 rounded-lg bg-white p-6 w-full flex flex-col gap-6">
          <p class="text-zinc-800 font-semibold text-lg">결제 안내</p>
          <div class="flex flex-col lg:flex-row gap-3">
            <p
              class="sb-aggro text-zinc-800 text-base lg:text-lg font-light leading-tight break-keep mr-auto">
              {{ paymentAccount().bankName }}
            </p>
            <p class="flex items-center gap-2 text-zinc-400 font-medium">
              계좌번호<span class="text-zinc-800 font-medium">{{
                paymentAccount().accountNumber
              }}</span>
            </p>
            <p class="flex items-center gap-2 text-zinc-400 font-medium">
              예금주<span class="text-zinc-800 font-medium">{{
                paymentAccount().accountHolder
              }}</span>
            </p>
          </div>
          <div class="p-4 rounded-lg bg-zinc-50 flex flex-col gap-1">
            <p class="text-sm text-zinc-800 font-bold">확인해주세요</p>
            <ul
              class="list-disc list-inside text-zinc-400 text-sm space-y-1 pl-5">
              <li>
                계약금 납부
                <span class="text-zinc-600 font-medium">
                  신청계약서 제출 후 3일이내 총참가비의 50%납부 / 잔금은 각 행사
                  한 달 전까지 납부
                </span>
              </li>
              <li>
                카드결제
                <span class="text-zinc-600 font-medium">
                  회사로 연락해서 해당카드번호를 불러주시면 결제 후 영수증은
                  메일이나 메시지로 발송
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 이용약관 -->
      <div
        class="border border-zinc-200 rounded-lg bg-white p-6 w-full flex flex-col gap-6">
        <p class="text-zinc-800 font-semibold text-lg">이용약관</p>
        <div class="flex flex-col gap-3">
          <div [class.active]="allAgreed()" class="flex gap-2">
            <app-checkbox
              [ngModel]="allAgreed()"
              (ngModelChange)="allAgreed.set($event)" />
            <span class="text-zinc-800 font-medium">전체 동의하기</span>
          </div>
          <div class="w-full h-px bg-zinc-100"></div>
          <div [class.active]="isTermsAgreed()" class="flex gap-2 items-start">
            <app-checkbox
              [ngModel]="isTermsAgreed()"
              (ngModelChange)="isTermsAgreed.set($event)" />
            <span class="text-zinc-500 font-medium flex-1"
              ><span class="text-primary-500">(필수)</span> 이용약관동의</span
            >
            <app-icon
              name="material-symbols:chevron-right"
              class="size-5! text-zinc-300 cursor-pointer"
              (click)="openPolicy.emit('use')" />
          </div>

          <div
            [class.active]="isPrivacyAgreed()"
            class="flex gap-2 items-start">
            <app-checkbox
              [ngModel]="isPrivacyAgreed()"
              (ngModelChange)="isPrivacyAgreed.set($event)" />
            <span class="text-zinc-500 font-medium flex-1"
              ><span class="text-primary-500">(필수)</span>
              개인정보이용동의</span
            >
            <app-icon
              name="material-symbols:chevron-right"
              class="size-5! text-zinc-300 cursor-pointer"
              (click)="openPolicy.emit('privacy')" />
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class TermsAgreementComponent {
  paymentAccount = createPaymentAccountSignal('agritex');
  allAgreed = model(false);
  isTermsAgreed = model(false);
  isPrivacyAgreed = model(false);

  openPolicy = output<'use' | 'privacy'>();
}
